import { render, staticRenderFns } from "./listaCertificados.vue?vue&type=template&id=21491a4d"
import script from "./listaCertificados.vue?vue&type=script&lang=js"
export * from "./listaCertificados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports